import type { RecommendationDto } from '../services/MendsVisionService';

export type RecommendationTone = 'risk' | 'opp' | 'rec';

/** `kind` estruturado emitido pelo backend (GetRecommendationsAsync) — nunca inferir pelo texto livre. */
const RISK_KINDS = new Set(['leads_cooling', 'attendance_risk']);
const OPP_KINDS = new Set(['opportunity_recovery']);

/** Classifica recomendação da Central para colunas / cards de insight. */
export function classifyRecommendation(r: Pick<RecommendationDto, 'kind'>): RecommendationTone {
  const kind = (r.kind || '').trim().toLowerCase();
  if (RISK_KINDS.has(kind)) return 'risk';
  if (OPP_KINDS.has(kind)) return 'opp';
  return 'rec';
}

const OBJECT_TYPE_LABEL: Record<string, string> = {
  opportunity: 'oportunidade',
  contact: 'cliente',
  conversation: 'conversa',
  approval: 'aprovação',
  action: 'ação',
  nav: 'tela',
  event: 'compromisso',
};

/** Tipo de objeto afetado (`type` do backend) em português; tipo desconhecido não aparece cru. */
export function affectedObjectTypeLabel(type?: string | null): string | null {
  const key = (type || '').trim().toLowerCase();
  return OBJECT_TYPE_LABEL[key] ?? null;
}
